const r = {
  baseStyle: ({ theme: o }) => ({
    borderRadius: o.button.borderRadius,
    padding: o.button.mediumVertical,
    borderWidth: o.button.borderWidth
  }),
  sizes: {
    small: ({ theme: o }) => ({
      padding: o.buttonSmallButtonVertical,
      minHeight: o.buttonSmallHeight,
      ...o.button.smallText
    }),
    medium: ({ theme: o }) => ({
      padding: `${o.buttonMediumVertical} ${o.buttonMediumHorizontal}`,
      minHeight: o.buttonMediumHeight,
      ...o.button.mediumText
    }),
    large: ({ theme: o }) => ({
      padding: `${o.buttonLargeVertical} ${o.buttonLargeHorizontal}`,
      minHeight: o.buttonLargeHeight,
      ...o.button.largeText
    }),
    xsmall: ({ theme: o }) => ({
      padding: 0,
      margin: 0,
      minHeight: o.filter.chipIcon,
      ...o.button.smallText
    })
  },
  variants: {
    primary: ({ theme: o }) => ({
      backgroundColor: o.action.primaryDefault,
      color: o.text.onActionPrimary,
      borderColor: o.border.actionPrimary,
      _hover: {
        backgroundColor: o.action.primaryHover,
        borderColor: o.border.actionPrimaryPressed,
        color: o.text.onActionPrimaryPressed
      },
      _focus: {
        backgroundColor: o.action.primaryFocus,
        borderColor: o.border.actionPrimary,
        color: o.text.onActionPrimary
      },
      _active: {
        backgroundColor: o.action.primaryPressed,
        borderColor: o.border.actionPrimaryPressed,
        color: o.text.onActionPrimaryPressed
      },
      _loading: {
        backgroundColor: o.action.primaryLoading,
        borderColor: o.border.actionPrimary
      },
      _disabled: {
        backgroundColor: o.action.primaryDisabled,
        opacity: 1,
        borderColor: o.border.actionPrimaryDisabled,
        color: o.text.onActionPrimaryDisabled
      }
    }),
    secondary: ({ theme: o }) => ({
      backgroundColor: o.action.secondaryDefault,
      color: o.text.onActionSecondary,
      borderColor: o.border.actionSecondary,
      _hover: {
        backgroundColor: o.action.secondaryHover,
        borderColor: o.border.actionSecondaryPressed,
        color: o.text.onActionSecondaryPressed
      },
      _focus: {
        backgroundColor: o.action.secondaryFocus,
        borderColor: o.border.actionSecondary,
        color: o.text.onActionSecondary
      },
      _active: {
        backgroundColor: o.action.secondaryPressed,
        borderColor: o.border.actionSecondaryPressed,
        color: o.text.onActionSecondaryPressed
      },
      _loading: {
        backgroundColor: o.action.secondaryLoading,
        borderColor: o.border.actionSecondary
      },
      _disabled: {
        backgroundColor: o.action.secondaryDisabled,
        opacity: 1,
        borderColor: o.border.actionSecondaryDisabled,
        color: o.text.onActionSecondaryDisabled
      }
    }),
    tertiary: ({ theme: o }) => ({
      backgroundColor: o.action.tertiaryDefault,
      color: o.text.onActionTertiary,
      borderColor: o.border.actionTertiary,
      _hover: {
        backgroundColor: o.action.tertiaryHover,
        borderColor: o.border.actionTertiaryPressed,
        color: o.text.onActionTertiaryPressed
      },
      _focus: {
        backgroundColor: o.action.tertiaryFocus,
        borderColor: o.border.actionTertiary,
        color: o.text.onActionTertiary
      },
      _active: {
        backgroundColor: o.action.tertiaryPressed,
        borderColor: o.border.actionTertiaryPressed,
        color: o.text.onActionTertiaryPressed
      },
      _loading: {
        backgroundColor: o.action.tertiaryLoading,
        borderColor: o.border.actionTertiary
      },
      _disabled: {
        backgroundColor: o.action.tertiaryDisabled,
        opacity: 1,
        borderColor: o.border.actionTertiaryDisabled,
        color: o.text.onActionTertiaryDisabled
      }
    }),
    transparent: ({ theme: o }) => ({
      backgroundColor: "transparent",
      color: o.text.deemphasized,
      _hover: {
        backgroundColor: "transparent"
      },
      _focus: {
        backgroundColor: "transparent"
      },
      _active: {
        backgroundColor: "transparent"
      },
      _loading: {
        _disabled: {
          backgroundColor: o.action.tertiaryLoading,
          opacity: 1
        }
      }
    }),
    accent: ({ theme: o }) => ({
      backgroundColor: o.background.accent3Subdued,
      color: o.icon.accent3,
      _hover: {
        backgroundColor: o.background.accent3Subdued
      },
      _focus: {
        backgroundColor: o.background.accent3Subdued
      },
      _active: {
        backgroundColor: o.background.accent3SubduedPressed
      }
    }),
    onActionTertiary: ({ theme: o }) => ({
      backgroundColor: o.palette.none,
      color: o.text.onActionTertiary,
      _hover: {
        color: o.text.onActionTertiaryPressed
      },
      _focus: {
        color: o.text.onActionTertiaryPressed
      },
      _active: {
        color: o.text.onActionTertiaryPressed
      },
      _loading: {
        _disabled: {
          color: o.onActionTertiaryDisabled,
          opacity: 1
        }
      }
    })
  },
  defaultProps: {
    size: "medium",
    variant: "primary"
  }
};
export {
  r as default
};
